import aboutUsImg from "~/assets/images/about-us/about-us-breadcrumb.webp";
import durafin from "~/assets/images/about-us/durafin.webp";
import flexible from "~/assets/images/about-us/flexible-design.webp";
import missionMobile from "~/assets/images/about-us/Ikhtebar-mission-mobile.webp";
import mission from "~/assets/images/about-us/Ikhtebar-mission.webp";
import visionMobile from "~/assets/images/about-us/ikhtebar-vision-mobile.webp";
import vision from "~/assets/images/about-us/Ikhtebar-vision.webp";
import ikhtebar from "~/assets/images/about-us/ikhtebar.webp";
import visionImg from "~/assets/images/about-us/vision.webp";
import zamilTraining from "~/assets/images/about-us/zamil-training.webp";
import {
  HVACIcon,
  InsulationIcon,
  SteelIcon,
} from "~/design-system/components/icons";
import { URLS } from "~/shared/urls";

export const zamilTrainingAndIkhtebarData = [
  {
    description: "aboutUsPages.trainingCenter",
    image: zamilTraining,
  },
  {
    description: "aboutUsPages.ikhtebarLab",
    image: ikhtebar,
  },
];

export const ikhtebarVisionAndMissionSectionItems = [
  {
    img: vision,
    imgMobile: visionMobile,
    description: "aboutUsPages.ikhtebarVision",
  },
  {
    img: mission,
    imgMobile: missionMobile,
    description: "aboutUsPages.ikhtebarMission",
  },
];

export const aboutAirConditioningBreadcrumb = {
  image: aboutUsImg,
  items: [
    { text: "home", href: URLS.home },
    { text: "aboutUs", href: URLS.aboutUs.root },
    // { text: "aboutUsPages.zamilAirConditioner" },
  ],
};

export const aboutSynexisBreadcrumb = {
  image: aboutUsImg,
  items: [
    { text: "home", href: URLS.home },
    { text: "aboutUs", href: URLS.aboutUs.root },
    { text: "aboutUsPages.zamilIndustrial" },
  ],
};

export const aboutIkhtebarBreadcrumb = {
  image: aboutUsImg,
  items: [
    { text: "home", href: URLS.home },
    { text: "about", href: URLS.aboutUs.root },
    { text: "aboutUsPages.testingIkhtebar" },
  ],
};

export const aboutUsBreadcrumb = {
  image: aboutUsImg,
  items: [
    { text: "home", href: URLS.home },
    { text: "about", href: URLS.aboutUs.root },
    { text: "aboutUsPages.senaat" },
  ],
};

export const aboutUsSamsungBreadcrumb = {
  image: aboutUsImg,
  items: [
    { text: "home", href: URLS.home },
    { text: "about", href: URLS.aboutUs.root },
    { text: "samsung_VRX_DVM_Tech" },
  ],
};

export const aboutViewAndCoreBreadcrumb = {
  image: aboutUsImg,
  items: [
    { text: "home", href: URLS.home },
    { text: "aboutUs", href: URLS.aboutUs.root },
    { text: "aboutUsPages.visionMission" },
  ],
};

export const aboutSynexisTexts = [
  "synexisCollaborationIntro",
  "ieqSectorCommitment",
  "dhpTechnologyAndPartnership",
  "collaborationCommitment",
  "visionAlignment",
];

export const zamilIndustrialServicespoints = [
  "aboutUsPages.zamilIndustrialGlobalPresence",
  "aboutUsPages.zamilIndustrialServices",
  "aboutUsPages.zamilIndustrialEmployment",
  "aboutUsPages.zamilIndustrialShares",
];

export const zamilIndustrialServicesoverviewPoints = [
  "aboutUsPages.zamilIndustrialOverview",
  "aboutUsPages.zamilIndustrialProjects",
  "aboutUsPages.zamilIndustrialSolutions",
];

export const totalBuildingOverviewPoints = [
  "aboutUsPages.zamilIndustrialTotalBuildingSolutions",
  "aboutUsPages.zamilIndustrialInnovation",
  "aboutUsPages.zamilIndustrialManufacturingFacilities",
];

export const zamilIndustrialSectors = [
  {
    label: {
      en: "Insulation",
      ar: "المواد العازلة",
    },
    Icon: InsulationIcon,
  },
  {
    label: {
      en: "HVAC",
      ar: "تكييف الهواء",
    },
    Icon: HVACIcon,
  },
  {
    label: {
      en: "Steel",
      ar: "الحديد",
    },
    Icon: SteelIcon,
  },
];

export const advancedCompressorItems = ["largestCapacityNote"];
export const automaticallyImproveItems = [
  "autoEfficiencyNote1",
  "autoEfficiencyNote2",
  "autoEfficiencyNote3",
];
export const maximumEnergyItems = [
  "reduceCostsNote1",
  "reduceCostsNote2",
  "reduceCostsNote3",
  "reduceCostsNote4",
];
export const whySamsungItems = [
  {
    img: durafin,
    title: "permanentProtection",
    subTitle: "durafinUltra",
    description: "durafinUltraDescription",
    points: ["durafinUltraNote1", "durafinUltraNote2"],
  },
  {
    img: flexible,
    title: "flexibleDesign",
    subTitle: "thinnerTube",
    description: "flexibleDesignDescription",
    points: ["flexibleDesignNote1", "flexibleDesignNote2"],
  },
];

export const coreValuesItems = [
  { title: "quality", description: "descriptionQuality" },
  { title: "sustainability", description: "descriptionSustainability" },
  { title: "integrity", description: "integrityDescription" },
  { title: "innovation", description: "innovationDescription" },
  { title: "customerCentric", description: "customerCentricDescription" },
  { title: "reliability", description: "reliabilityDescription" },
  { title: "safety", description: "safetyDescription" },
];

export const visionMissionItems = [
  {
    img: visionImg,
    title: "aboutUsPages.vision",
    content: "aboutUsPages.companyVision",
  },
  {
    img: mission,
    title: "aboutUsPages.mission",
    content: "aboutUsPages.companyMission",
  },
];
